// 跳转页面
export function showPage(page){
  this?.$store.commit('setCurrentPage', page)
}

// 显示弹窗
export function showPop(pop){
  this?.$store.commit('setCurrentPop', pop)
}

// 关闭弹窗
export function closePop(){
  this?.$store.commit('setCurrentPop', '')
}

// 更新玩家信息
export function updateInitUser(){
  this?.$store.dispatch('updateInitUser')
}





